const cambridgeInnovationThemeVariables = {
    footer__navIcon: 'arrow',
    footer__sectionPartPrefix: true,
    header__hidePreloadCaption: true,
    header__logoPath: 'images/logo/cambridge.png',
    header__showSkipLink: false,
    options__fileDeliveryIcon: 'fa-floppy-o',
    options__moveFileDeliveryToInvigilator: true,
    question__displayTokensVertically: true,
    question__wideAndLeftAlign: true,
    rubric__showQuestionRubric: true,
    rubric__showSectionRubric: true,
    scorableItemsDash: '–',
    stimulus__showMargins: false,
};

export default cambridgeInnovationThemeVariables;
